import { useMutation } from "@apollo/client";
import { useAlerts } from "components/Alerts/AlertProvider";

import { CONDUCT_COHORT_MUTATION } from "./api";
import { useCohortDetails } from "./useCohortDetails";

export function useConductCohort() {
  const { refetch } = useCohortDetails();
  const alerts = useAlerts();

  const [conductCohortMutation, { loading, error }] = useMutation(CONDUCT_COHORT_MUTATION, {
    onCompleted: () => {
      refetch();
      alerts.success("Cohort conduction initiated successfully");
    },
    onError: (error) => {
      alerts.error("Failed to conduct cohort", error);
    },
  });

  const conductCohort = (cohortId: string) => {
    return conductCohortMutation({
      variables: { cohortId },
    });
  };

  return {
    conductCohort,
    loading,
    error,
  };
}
